export default __webpack_public_path__ + "static/media/github.5700368c.png";